<template>
  <div
    class="border mt-1 rounded max-h-[90vh] p-2 text-xl min-w-[22.7%] mx-1 text-left px-4 py-3"
    :class="
      (resolvidos
        ? 'text-[#009285] border-2 border-[#009285] bg-[#00928620]'
        : '',
      controlados
        ? 'text-[#B49B5A]  border-2 border-[#B49B5A] bg-[#B49B5A20]'
        : '',
      cancelados
        ? 'text-[#898989] border-2 border-[#898989] bg-[#89898920]'
        : '',
      criticos ? 'text-[#920000] border-2 border-[#920000] bg-[#92000020]' : '')
    "
  >
    <div v-if="isLoad">
      <Loading4Dots />
    </div>
    <h1 v-else>
      <span class="font-semibold">
        {{ props.value }}
      </span>
      <br />
      <div class="flex flex-col">
        <span class="text-gray-500 text-base">
          {{ props.label == "Crítico" ? "Não controlado" : props.label }}
        </span>
        <small class="text-gray-400 text-xs"> Neste mes </small>
      </div>
    </h1>
  </div>
</template>

<script setup>
import Loading4Dots from "@/components/Loading4Dots.vue";
import { dataRcd } from "../../store";
import { computed } from "vue";

const isLoad = computed(() => dataRcd.getters.isCardLoad);
const props = defineProps({
  label: String,
  value: [String, Number],
  resolvidos: { Boolean, default: false },
  controlados: { Boolean, default: false },
  cancelados: { Boolean, default: false },
  criticos: { Boolean, default: false },
});
</script>
